import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorPage } from '@/pages/Error/ErrorPage';

interface ErrorBoundaryProps {
  error: Error;
  reset: () => void;
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ error }) => {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: {
        errorBoundary: 'route',
      },
    });
  }, [error]);

  return <ErrorPage />;
};
